// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { auditEventsResponseSchema } from '@/audit/api/types';

/**
 * Request a list of audit events for a location from the remote API.
 *
 * @param key - The key of the location for which to request audit events.
 */
export async function getSiteAuditEvents(key: string) {
  const url = `/v1/location/SITE/${key}/audit`;
  const response = await api.get(url);

  return parseResponse(auditEventsResponseSchema, response.data, {
    schemaName: 'SiteAuditEvents',
    endpoint: url,
  });
}
